/*
 * @Author: leo.si
 * @Date: 2019-08-01 11:39:19
 * @Last Modified by: Rowe
 * @Last Modified time: 2019-08-19 16:38:09
 * @function window.requestAnimationFrame
 * The window.requestAnimationFrame() method tells the browser that you wish to perform an animation and requests that the browser call a specified function to update an animation before the next repaint. The method takes a callback as an argument to be invoked before the repaint.
 * @params fn ==> function
 * @params id ==> Number
 * 一个定时器的写法案例
 *  let animationFrame = new AnimationFrame()
    let a = 0;
    let id  = animationFrame.callRequestAnimationFrame(function fn(){
      if(a==5){
        animationFrame.callCancelAnimationFrame(id)
      }else{
        id = animationFrame.callRequestAnimationFrame(fn)
      }
      console.log('a------',a)
      a++;
    })
*/

class AnimationFrame {
    callRequestAnimationFrame(fn = function () { }) {
      return this.redefinitionRequestAnimationFrame(fn)
    }
    callCancelAnimationFrame(id) {
      return this.redefinitionCancelAnimationFrame(id)
    }
    redefinitionRequestAnimationFrame(fn) {
      if(window.requestAnimationFrame){
        return window.requestAnimationFrame(fn);
      }else if(window.webkitRequestAnimationFrame){
        return window.webkitRequestAnimationFrame(fn);
      }else if(window.mozRequestAnimationFrame){
        return window.mozRequestAnimationFrame(fn)
      }else{
        return function (fn) { window.setTimeout(fn, 1e3 / 60, (new Date()).getTime() )(); }
      }
    }
    redefinitionCancelAnimationFrame(id) {
      if(window.cancelAnimationFrame){
        return window.cancelAnimationFrame(id)
      }else if(window.webkitCancelAnimationFrame){
        return window.webkitCancelAnimationFrame(id)
      }else if(window.mozCancelAnimationFrame){
        return window.mozCancelAnimationFrame(id)
      }else{
        return function (id) { clearTimeout(id); }();
      }
    }
  }
  
  module.exports = AnimationFrame;


// WEBPACK FOOTER //
// ./common/lib/AnimationFrame.js